import { supabaseClient } from './supabase';
import type { EventRow, EventRowInsert } from '@shared-types/events.types';
import camelcaseKeys from 'camelcase-keys';
import { EdgeFunctionsManager } from '@/utils/edge-functions-manager';

export const getUserEvents = async (organizationId: string): Promise<EventRow[]> => {
    const { data, error } = await supabaseClient.from('events').select('*').eq('organization_id', organizationId);

    if (error) {
        throw error;
    }

    return camelcaseKeys(data);
};

export const addEvent = async (event: EventRowInsert) => {
    await EdgeFunctionsManager.addEvent(event);
};
